import 'regenerator-runtime/runtime';
import axios, { AxiosRequestHeaders, Method, ResponseType } from 'axios';
import NextPairRanking from '~types/api/NextPairRanking';
import AssessmentStartKit from '~types/AssessmentStarterKit';
import SendToDelegatorData from '~types/api/SendToDelegatorData';
import SendToDelegatorParameters from '~types/api/SendToDelegatorParameters';
import SendErrorToDelegatorData from '~types/api/SendErrorToDelegatorData';
import * as constants from '../constants/constants';

const assessment = (
  method: Method,
  headers?: AxiosRequestHeaders,
  params?: any
) => {
  let baseUrl: string;
  if (window.location.host.includes('localhost')) {
    // baseUrl = constants.LOCAL_ASSESSMENT_API_BASE;
    baseUrl = `https://prp-mypriorities-gtwy.apps2.devjones.com${constants.ASSESSMENT_API_BASE}`;
  } else {
    baseUrl = constants.ASSESSMENT_API_BASE;
  }
  return axios.create({
    baseURL: baseUrl,
    method,
    headers: {
      withCredentials: 'true',
      'Cache-Control': 'no-store',
      ...headers,
    },
    params,
  });
};

const delegator = (
  responseType: ResponseType,
  method: Method,
  params?: any
) => {
  let baseURL: string;
  if (window.location.host.includes('localhost')) {
    // baseURL = constants.LOCAL_DELEGATOR_API_BASE;
    baseURL = `https://prp-mypriorities-gtwy.apps2.devjones.com${constants.DELEGATOR_API_BASE}`;
  } else {
    baseURL = constants.DELEGATOR_API_BASE;
  }
  return axios.create({
    baseURL,
    method,
    headers: {
      'Content-Type': 'application/json',
      credentials: 'include',
      'Cache-Control': 'no-store',
    },
    responseType,
    params,
  });
};

const featureGateway = (method: Method) => {
  let baseURL: string;
  if (window.location.host.includes('localhost')) {
    // baseURL = constants.LOCAL_FEATURE_API_BASE;
    baseURL = `https://prp-mypriorities-gtwy.apps2.devjones.com${constants.FEATURE_API_BASE}`;
  } else {
    baseURL = constants.FEATURE_API_BASE;
  }
  return axios.create({
    baseURL,
    method,
    headers: {
      credentials: 'include',
      'Cache-Control': 'no-store',
    },
  });
};

export const getSchema = (
  locId: string,
  conId: string,
  utmSource: string,
  conType: string,
  faNo: string,
  entityIdBase64: string
): Promise<AssessmentStartKit> => {
  return assessment('get')
    .get('values/', {
      params: {
        sysId: 'PRP',
        appName: 'MyPriorities',
        conId,
        faNo,
        locId,
        utmSource,
        conType,
        entityIdBase64,
      },
    })
    .then((res) => res.data);
};

export const getNextPair = (data: string): Promise<NextPairRanking> => {
  const headers = {
    'Content-Type': 'application/json',
  };
  const params = {
    sysId: 'PRP',
    appName: 'MyPriorities',
  };
  const url = 'ranking/';
  return assessment('post', headers, params)
    .post(url, data)
    .then((res) => res.data);
};

export const sendToDelegator = (
  params: SendToDelegatorParameters,
  data: SendToDelegatorData,
  responseType: ResponseType
): Promise<string> => {
  let url;
  if (responseType === 'blob') {
    url = 'results-pdf/';
  } else {
    url = 'process-request/';
  }
  return delegator(responseType, 'post', params)
    .post(url, data)
    .then((res) => res.data);
};

export const isMpUsFinancialPlanningContentActive = (): Promise<boolean> => {
  const url = '/mp/us-fp-active';
  return featureGateway('get')
    .get(url)
    .then((res) => res.data);
};

export function sendErrorToDelegator(
  data: SendErrorToDelegatorData,
  locId: string
) {
  let url;
  if (window.location.host.includes('localhost')) {
    url = constants.ERROR_API_LOCAL;
  } else {
    url = constants.ERROR_API;
  }
  return axios({
    method: 'post',
    url,
    params: {
      sysId: 'PRP',
      appName: 'MyPriorities',
      locale: locId,
    },
    data,
  }).then((res) => res.data);
}

export async function sendErrorBodyToDelegator(
  supportId: string,
  locId: string
): Promise<void> {
  try {
    const data = {
      appName: 'MyPriorities',
      locale: locId,
      aviSupportId: supportId,
      errorDateTime: new Date().toISOString(),
    };
    await sendErrorToDelegator(data, locId);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
}

export function handleAVIError(error: any, locId: string): void {
  try {
    const htmlString = error.response.data;
    const startTextLocation = htmlString.indexOf('ID:');
    const endTextLocation = htmlString.indexOf('and');
    const supportId = htmlString
      .slice(startTextLocation + 4, endTextLocation)
      .trim(); // Removing all text except the supportId.
    sendErrorBodyToDelegator(supportId, locId);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err);
  }
}
